import { defineComponent as _defineComponent } from 'vue'
import {
  useInteractive,
  useSend,
  buildModelPath
} from '@/app/program/hook/serve'
import { ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props, { expose: __expose }) {
  __expose();

const sceneLocal = ref(buildModelPath)
const selectDir = async () => {
  const { data, err } = await useInteractive('selectDir', {
    title: '选择场景存放路径'
  })
  if (data) {
    sceneLocal.value = data
  }
}

const __returned__ = { sceneLocal, selectDir, get useSend() { return useSend }, get buildModelPath() { return buildModelPath } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})